import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchBrandTags,
  SearchBrandTagsVariables
} from "./types/SearchBrandTags";

export const searchBrandTags = gql`
  ${pageInfoFragment}
  query SearchBrandTags($after: String, $first: Int!, $query: String!) {
    search: brandTags(
      after: $after
      first: $first
      filter: { search: $query }
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchBrandTags, SearchBrandTagsVariables>(
  searchBrandTags
);
